<!-- Color Light-Blue  #1a6fb0 -->
<template>
  <div class="bg-light">
    <navbar evalExtern informExtern/>
    <main class="" style="padding-top: 0rem;">
      <section class="mx-auto" style="max-width: 1200px">
        <div class="px-0 px-xl-5 workingIcon">
          <div class="container py-5 mb-lg-3">
            <div class="row justify-content-center pt-lg-4 text-center">
              <div class="col-lg-7 col-md-7 col-sm-9">
                <h1 class="display-404">Sry..</h1>
                <h2 class="h3 mb-4">
                  Aufgrund der großen Nachfrage sind wir leider gerade an unsere Kapazitätsgrenze gestoßen.
                </h2>
                <div class="widget pb-2 mb-5 pt-4">
                  <h3 class="widget-title pb-0 mb-2 text-center">Wir benachrichtigen dich, sobald wieder freie Kapazität zu Verfügung steht.</h3>
                  <p class="py-0 mt-0 font-size-xs text-center">Dein Interesse hilft uns dabei in Zukunft besser zu planen</p> 
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-xl-8 col-lg-10">
                <div class="row justify-content-center">
                  <div class="col-sm-4 mb-3">
                    <a class="card h-100 border-0 box-shadow-sm" href="/">
                      <div class="card-body">
                        <div class="media align-items-center">
                          <i class="czi-home text-dark h4 mb-0"></i>
                          <div class="media-body pl-3">
                            <h5 class="font-size-sm mb-0">Home</h5>
                            <span class="text-muted font-size-ms">wirkaufendeine-kueche.de</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <div class="pb-4"></div>
        </div>
      </section>
      <myFooter />
    </main>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import Vue from "vue"
import navbar from "@/components/navbar.vue"
import myFooter from "@/components/footer.vue"

export default {
  name: 'termin',
  components: {
    navbar,
    myFooter
  },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data: () => ({
  }),
  computed: {
  },
  created: function () {
    this.meetingAccepted(this.id);
  },
  mounted: function () {
    Vue.nextTick(() => {
      this.loadBootstrapTheme();
    });
  },
  methods: {
    loadBootstrapTheme: function () {
      let theme = document.createElement('script')
      theme.setAttribute('src', 'theme.js')
      document.head.appendChild(theme) 
    },
    ...mapActions(['appManagerDispatch']),
    meetingAccepted: async function (id) {
      //window.myGTag('event', 'conversion', {'send_to': 'AW-717328684/3UbDCNXArNUBEKyihtYC'});
      await this.appManagerDispatch({action: "meetingAccepted", payload: id});
    }, 
  }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .workingIcon {
    background-image: url("/img/myDesigns/icons/underLoad.svg"); /* The image used */
    height: 100%;
    background-position: 90% 10%; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: fit; /* Resize the background image to cover the entire container */
  }
}
</style>